/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class DeploymentModeStrService {
    get = this.i18nService.get;

    i18n = {
        deploymentModeWarning: this.get('common.initializeConfiguration_remoteDeployment_info'),
        endBtnLable: this.get('settings.alarmNotification_maintenanceWindow_end_btn'),
        deploymentModeEndTitle: this.get('common.DMEIQ_remoteDeployment_stop_title'),
        deploymentModeEndWarning: this.get('common.DMEIQ_remoteDeployment_stop_confirm_msg'),
    };

    constructor(
        private i18nService: I18nService,
    ) { }
}
